module.exports = __webpack_public_path__ + "files/ccf7a079dae45bad454c486a72ede8ee.png";